import { HttpResponse, delay, http } from 'msw';

import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformAuthenticateLocalUserMockHandler = () => {
  return http.post('*/user/authenticate', async (info) => {
    await delay(MOCK_DELAY);

    const body: any = await info.request.json();

    if (body?.email === 'admin@localhost' && body?.password === 'password') {
      return HttpResponse.json(
        {
          id_token: Math.random().toString(36).slice(2) + Date.now().toString(36),
        },
        { status: 200 },
      );
    }

    return HttpResponse.json(
      {
        message: 'Invalid credentials',
      },
      { status: 401 },
    );
  });
};
